import styled from "styled-components";

export const IconWrapper = styled.div<{ isCollapsed?: boolean }>`
	${(p) => (p.isCollapsed ? "transform: rotate(90deg);" : "transform: rotate(-90deg);")}
`;
